(function ($) {

    $('.partners-map-region-select .button').click(function(){
        let href = $(this).attr('href')
        let region = $('.partners-map-region-select select').val()
        window.location.href = href + '#region-' + region
        return false;
    });
  
  })(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/other-links.js